import React, { useEffect, useState } from "react";
import Dashboard from "../../../layouts/Dashboard";
import LoadingArea from "../../../components/LoadingArea";
import CandidatesTable from "../../../components/CandidatesTable";
import axios from "../../../services/axios";
import swal from "sweetalert";

export default function ReportsL1() {
  // States
  const [loading, setLoading] = useState(false);
  const [candidates, setCandidates] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [AppPage, setAppPage] = useState(
    localStorage.getItem("page") ? localStorage.getItem("page") : 1
  );
  const [LengthPages, setLengthPages] = useState("");

  const [formIds, setFormIds] = useState("");
  const [locationName, setLocationName] = useState("");
  const [candidateStatus, setCandidateStatus] = useState("");
  const [processId, setProcessId] = useState("");
  const [Input, setInput] = useState("");

  const [candidateCount, setCandidateCount] = useState(0);
  const [startDates, setStartDates] = useState("");
  const [endDates, setEndDates] = useState("");

  const [score, setScore] = useState("");

  console.log("apppage", AppPage);
  console.log("totalPages", totalPages);

  //const [csv, setCsv] = useState([])
  localStorage.setItem("page", AppPage);

  const [refresh, setRefresh] = useState("");

  // Effects
  useEffect(() => {
    localStorage.setItem("page", AppPage);
    setRefresh("H");
  }, []);

  const GetValue = (val) => {
    setAppPage(val.val);
  };

  // async function loadCandidates() {
  //   try {
  //      const res = await axios.get("candidates/small-l1");
  //     //const res = await axios.get("http://172.17.103.25:4000/api/candidates/candidateCount2?FormId=&PageSize=10&PageNo=1&Search=&Location=&Position=Kolkata&Status=&InterviewRound=1&ProcessId=");

  //     setCandidates(res.data.candidates);
  //     setLoading(false);
  //     setTotalPages(res.data.totalPages);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // api for formname and id
  //  useEffect(() => {
  //   axios.get("/formtemplate")
  //   .then(res => {
  //     const data = res.data
  //     setFormName(data)
  //   })
  // }, [])
  const [load, setLoad] = useState(true);

  useEffect(() => {
    setFormIds(localStorage.getItem("form_ids"));
    if (formIds !== "") {
      setLoad(false);
    }
    {
      formIds !== "" &&
        setProcessId(
          localStorage.getItem("selectProcess")
            ? localStorage.getItem("selectProcess")
            : ""
        );
      setScore(
        localStorage.getItem("selectScore")
          ? localStorage.getItem("selectScore")
          : ""
      );
      setLocationName(
        localStorage.getItem("selectLocation")
          ? localStorage.getItem("selectLocation")
          : ""
      );
      setCandidateStatus(
        localStorage.getItem("selectStatus")
          ? localStorage.getItem("selectStatus")
          : ""
      );
    }

    loadCandidates();
  }, [
    AppPage,
    formIds,
    locationName,
    candidateStatus,
    processId,
    Input,
    score,
    refresh,
    startDates,
    endDates,
  ]);

  async function loadCandidates() {
    try {
      {
        formIds !== "" &&
          (await axios
            .get(
              `candidates/candidateCount2?FormId=${formIds}&PageSize=10&PageNo=${
                localStorage.getItem("page") ? localStorage.getItem("page") : ""
              }&Search=${
                localStorage.getItem("numberSearch")
                  ? localStorage.getItem("numberSearch")
                  : ""
              }&Location=&Position=${
                localStorage.getItem("selectLocation")
                  ? localStorage.getItem("selectLocation")
                  : ""
              }&Status=${
                localStorage.getItem("selectStatus")
                  ? localStorage.getItem("selectStatus")
                  : ""
              }&InterviewRound=1&ProcessId=${
                localStorage.getItem("selectProcess")
                  ? localStorage.getItem("selectProcess")
                  : ""
              }&ScoreType=${
                localStorage.getItem("selectScore")
                  ? localStorage.getItem("selectScore")
                  : ""
              }&StartDate=${startDates}&EndDate=${endDates}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("user.token")}`,
                },
              }
            )
            .then((res) => {
              const data = res.data.interview;
              setLengthPages(res.data.interviewCount);
              setCandidateCount(res.data.interviewCount);
              setCandidates(data);
              if (data !== "") {
                setLoad(true);
              }
              //setLengthPages(res.data.candidateCount)
              setLoading(false);
              setTotalPages(1);
            })
            .catch((e) => {
              setLoad(true);
              swal("Oops...", "Something went wrong!", "Network Error");
            }));
      }
    } catch (e) {
      console.log(e);

      swal("Oops...", "Something went wrong!", "Network Error");
    }
  }
  //Candidates at L2 Interview
  const counts = `Candidates ${candidateCount}`;

  // filter download csv according to apply mltiple filters

  // useEffect(() => {
  //   axios.get(`candidates/DownloadInterviewCandidateCSV?FormId=${formIds}&PageSize=10&PageNo=1&Search=${Input}&Location=&Position=${locationName}&Status=${candidateStatus}&InterviewRound=1&ProcessId=${processId}
  //   `)
  //   .then(res => {
  //     const data = res.data.interview
  //     setCsv(data)
  //   })
  // }, [formIds, Input, , locationName, candidateStatus, processId])

  /////////////////////////////////////
  const [csv, setCsv] = useState([]);
  const [dataStatus, setDataStatus] = useState(true);
  const [sta, setSta] = useState();
  const [info, setinfo] = useState("L1");
  async function csvDownload() {
    try {
      setSta(false);
      const res = await axios.get(
        `candidates/DownloadInterviewCandidateCSV?FormId=${formIds}&PageSize=10&PageNo=1&Search=${
          localStorage.getItem("numberSearch")
            ? localStorage.getItem("numberSearch")
            : ""
        }&Location=&Position=${
          localStorage.getItem("selectLocation")
            ? localStorage.getItem("selectLocation")
            : ""
        }&Status=${
          localStorage.getItem("selectStatus")
            ? localStorage.getItem("selectStatus")
            : ""
        }&InterviewRound=1&ProcessId=${
          localStorage.getItem("selectProcess")
            ? localStorage.getItem("selectProcess")
            : ""
        }&ScoreType=${
          localStorage.getItem("selectScore")
            ? localStorage.getItem("selectScore")
            : ""
        }&StartDate=${startDates}&EndDate=${endDates}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      );
      setSta(true);
      setCsv(res.data.interview);
      return res.data.interview;
    } catch (e) {
      console.log(e);
    }
  }
  //console.log("csv data is", csv)

  return (
    <Dashboard title={counts}>
      <LoadingArea isLoading={loading}>
        <CandidatesTable
          csvDownload={csvDownload}
          candidates={candidates}
          setCandidates={setCandidates}
          totalPages={totalPages}
          LengthPages={LengthPages}
          GetValue={GetValue}
          info={info}
          setFormIds={setFormIds}
          formIds={formIds}
          setLocationName={setLocationName}
          locationName={locationName}
          setCandidateStatus={setCandidateStatus}
          candidateStatus={candidateStatus}
          setProcessId={setProcessId}
          processId={processId}
          setInput={setInput}
          setAppPage={setAppPage}
          startDates={startDates}
          setStartDates={setStartDates}
          endDates={endDates}
          setEndDates={setEndDates}
          csv={csv}
          setCsv={setCsv}
          dataStatus={dataStatus}
          setDataStatus={setDataStatus}
          sta={sta}
          setSta={setSta}
          load={load}
          setLoad={setLoad}
          score={score}
          setScore={setScore}
        />
      </LoadingArea>
    </Dashboard>
  );
}
